import { Box, Divider } from "@chakra-ui/react";
import { Activity } from "common";
import { get12HrTime } from "../utils/time";
import { MarkdownRenderer } from "../utils/MarkdownRenderer";

interface ActivityCardBigProps {
  activity: Activity;
}

export const ActivityCardBig = ({ activity }: ActivityCardBigProps) => {
  return (
    <Box>
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Box fontWeight={"bold"} fontSize={"1.5rem"}>
          {activity.title}
        </Box>
      </Box>
      <Box
        opacity={"0.6"}
        fontSize={"1.2rem"}
        fontWeight={"bold"}
      >{`${get12HrTime(activity.startTime)} - ${get12HrTime(
        activity.endTime
      )}`}</Box>
      <Divider marginTop={"1rem"} marginBottom={"1rem"} />
      <MarkdownRenderer>{activity.description}</MarkdownRenderer>
    </Box>
  );
};
